const SysLabels = {
  emptyResults: "No se encontraron resultados",
  actionNotReversed: "Esta acción no se puede revertir",
};

export default SysLabels;
